import api from "../services/apiConfig";

export const unitService = {
  getUnitDetails: async (timestamp) => {
    try {
      const response = await api.get("api/solar-unit/", {
        params: {
          current_time: timestamp,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUnitDetailsById: async (solor_unit_id) => {
    try {
      const response = await api.get(`api/solar-unit/${solor_unit_id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createUnit: async (data, timestamp) => {
    try {
      const response = await api.post("api/solar-unit/", data, {
        params: {
          current_time: timestamp,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteUnit: async (solar_unit_id) => {
    try {
      const response = await api.delete(`api/solar-unit/${solar_unit_id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
